import { Tablist, Tab, Pane } from 'evergreen-ui';
import React, { Component, useState } from 'react';

export const TabbedView = (props) => {
    let [ currentTab, setCurrentTab ] = useState(0);

    return (<Pane>
        <Pane>
            <Tablist marginBottom={16} marginRight={24}>
                {props.tabs.map((tab, index) => (
                <Tab
                    key={index}
                    id={index}
                    onSelect={() => setCurrentTab(index)}
                    isSelected={index === currentTab}
                    aria-controls={`panel-${tab}`}
                >
                    <div>{tab.title}</div>
                </Tab>
                ))}
            </Tablist>
        </Pane>
        
        {props.tabs.map((tab, index) => (
            <Pane  
                key={index}
                id={`panel-${tab}`}
                role="tabpanel"
                aria-labelledby={tab}
                aria-hidden={index !== currentTab}
                display={index === currentTab ? 'block' : 'none'}
            >
                {tab.component}
            </Pane>
        ))}    
        </Pane>
    )
}